import Vue from 'vue'
import {
  Button,
  Image as VanImage,
  Popup,
  Toast,
  Calendar,
  Checkbox, 
  CheckboxGroup,
  DatetimePicker,
  Field, 
  Form,  
  NumberKeyboard, 
  PasswordInput,
  Picker,
  RadioGroup, 
  Radio,
  Search,
  Switch, 
  Uploader,
  Dialog,
  DropdownMenu, 
  DropdownItem,
  Loading,
  Notify,
  Overlay,
  PullRefresh,
  Empty,
  ImagePreview,
  Lazyload,
  List,
  Popover,
  Progress,
  Swipe, 
  SwipeItem,
  Tab, 
  Tabs,
  Sticky,
  Grid, 
  GridItem,
  Icon,
  ActionSheet,
  Cell,
  CellGroup,
  Rate,
  NoticeBar,
  Cascader
} from 'vant'

Vue.use(Button)
.use(VanImage)
.use(Popup)
.use(Calendar)
.use(Checkbox)
.use(CheckboxGroup)
.use(DatetimePicker)
.use(Field)
.use(Form)
.use(NumberKeyboard)
.use(PasswordInput)
.use(Picker)
.use(Radio)
.use(RadioGroup)
.use(Search)
.use(Switch)
.use(Uploader)
.use(Dialog)
.use(DropdownMenu)
.use(DropdownItem)
.use(Loading)
.use(Notify)
.use(Overlay)
.use(PullRefresh)
.use(Empty)
.use(ImagePreview)
.use(Lazyload)
.use(List)
.use(Popover)
.use(Progress)
.use(Swipe)
.use(SwipeItem)
.use(Tab)
.use(Tabs)
.use(Sticky)
.use(Grid)
.use(GridItem)
.use(Icon)
.use(ActionSheet)
.use(Cell)
.use(CellGroup)
.use(Rate)
.use(NoticeBar)
.use(Cascader)
  Vue.prototype.$Toast = Toast;